import { InputRule } from '@milkdown/kit/prose/inputrules';
import { $inputRule } from '@milkdown/kit/utils';

import { embedNode } from '../embed';

/**
 * Iframe directive regex pattern for input rule
 * Matches: ::iframe{src="https://example.com"}
 * Supports both straight quotes (") and curly quotes (")
 */
export const IFRAME_INPUT_REGEX = /::iframe\{src=["\u201D](?<src>[^"\u201D]+)?["\u201D]\}/;

/**
 * Input rule: typing ::iframe{src="..."} creates an embed block with embedType 'iframe'
 */
export const iframeInputRule = $inputRule(
  (ctx) =>
    new InputRule(IFRAME_INPUT_REGEX, (state, match, start, end) => {
      const [, src = ''] = match;
      if (!src) {
        return null;
      }

      const { tr } = state;
      tr.replaceWith(start, end, embedNode.type(ctx).create({ href: src, embedType: 'iframe' }));

      return tr;
    }),
);
